import { render, staticRenderFns } from "./UserSentenceViewer.vue?vue&type=template&id=3abdfdb6&scoped=true&"
import script from "./UserSentenceViewer.vue?vue&type=script&lang=js&"
export * from "./UserSentenceViewer.vue?vue&type=script&lang=js&"
import style0 from "./UserSentenceViewer.vue?vue&type=style&index=0&id=3abdfdb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abdfdb6",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QCard,QCardSection,QSpace,QBtn});qInstall(component, 'directives', {ClosePopup});
